module.exports = __webpack_public_path__ + "img/aws.07cff81a.png";